// extracted by mini-css-extract-plugin
module.exports = {"campaign-reminder":"styles___campaign-reminder___23Ss4"};